import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import {
  RegionAndProvinceField as RHFRegionAndProvinceField,
  RegionAndProvinceFieldProps as RHFRegionAndProvinceFieldProps
} from '@anytag/shared-molecules';
import { InfluencerFormKeys, InfluencerFormValues } from '../InfluencerForm';
import { InfluencerSharedKeys } from './types';

interface RegionAndProvinceFieldProps {
  regionFieldProps?: Omit<RHFRegionAndProvinceFieldProps<InfluencerFormKeys>['regionFieldProps'], 'name'>;
  provinceFieldProps?: Omit<RHFRegionAndProvinceFieldProps<InfluencerFormKeys>['provinceFieldProps'], 'name'>;
}

export const RegionAndProvinceField = ({ regionFieldProps, provinceFieldProps }: RegionAndProvinceFieldProps) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<InfluencerFormValues>();

  const countryIdValue = watch(InfluencerSharedKeys.countryId);

  return (
    <RHFRegionAndProvinceField<InfluencerFormKeys>
      countryId={countryIdValue}
      regionFieldProps={{
        multiple: false,
        help: t('Tooltip.Region'),
        title: t('Selector.Region'),
        ...regionFieldProps,
        name: InfluencerSharedKeys.regionId
      }}
      provinceFieldProps={{
        help: t('Tooltip.City'),
        title: t('Selector.City'),
        ...provinceFieldProps,
        name: InfluencerSharedKeys.provinceId
      }}
    />
  );
};
